import Vue from "vue"

export function changeActiveStep(state, { step }) {
    state.activeStep = step
}

export function changeCurrentTeamId(state, { teamId }) {
    if(teamId) {
        state.currentTeamId = teamId.teamId
    }
}

export function retrieveEventIdSuccess(state, { eventId }) {
    state.eventId = eventId
}

export function retrieveEventIdError(state) {
    state.isBadEvent = true
}

export function retrieveEventSuccess(state, { event }) {
    state.event = event
}


const mapEntriesToTableAthletes = entries => (
    entries.map(entry => ({
        firstName: entry.firstName,
        lastName: entry.lastName,
        email: entry.email,
        gradYear: entry.gradYear,
        jerseyNumber: entry.jerseyNumber,
        positions: entry.positions,
        preCommitted: entry.preCommitted,
        guardianEmail1: entry.guardianEmail1,
        guardianEmail2: entry.guardianEmail2,
        phoneNumber: entry.phoneNumber,
    }))
)

export function removeAthleteFromRoster(state, index) {
    state.workspace.roster.splice(index, 1)
}

export function modifyAthleteFromRoster(state, { index, field, value }) {
    state.workspace.roster[index][field] = value
}

export function setRowToDelete(state, rowToDelete) {
    state.workspace.rowToDelete = rowToDelete
}

export function saveRoster(state, athletes) {
    state.roster = athletes
}

export function saveCoaches(state, coaches) {
    state.coaches = coaches
}

export function startRostering(state) {
    state.hasStartedRostering = true
}

export function setRoles(state, { roles }) {
    state.roles = roles
}

export function setContact(state, { identity }) {
    state.auth.nonIntegratedIdentity = identity
}

export function setRosterError(state, { rowId, fieldName, message, isRequired }) {
    if(!state.rosterErrors[rowId]) {
        state.rosterErrors[rowId] = {}
    }

    if(!state.rosterErrors[rowId][fieldName]) {
        state.rosterErrors[rowId][fieldName] = {}
    }

    if(!state.rosterErrors[rowId][fieldName]['error'] || state.rosterErrors[rowId][fieldName]['message'] !== message) {
        if(!state.rosterErrors[rowId][fieldName]['error']) {
            state.rosterErrorCount += 1;
            if(isRequired) {
                state.requiredErrorCount += 1;
            }
        }
        state.rosterErrors[rowId][fieldName]['error'] = true;
        state.rosterErrors[rowId][fieldName]['isRequired'] = isRequired;
        state.rosterErrors[rowId][fieldName]['message'] = message;
    }
}

export function removeRosterError(state, { rowId, fieldName, isRequired }) {
    if(state.rosterErrors[rowId][fieldName]['error']) {
        state.rosterErrorCount -= 1;
        if(isRequired) {
            state.requiredErrorCount -= 1;
        }
    }
    state.rosterErrors[rowId][fieldName]['error'] = false
    state.rosterErrors[rowId][fieldName]['message'] = ''
}

export function setPrimaryEmail(state, {email, position}) {
    state.duplicateEmails[position] = (email)
}

export function resetErrors(state) {
    state.rosterErrors = []
    state.rosterErrorCount = 0;
    state.requiredErrorCount = 0;
}

export function resetRowErrors(state, {row}) {
    if(state.rosterErrors[row.row]) {
        for (const [key, value] of Object.entries(state.rosterErrors[row.row])) {
            if(value['error']) {
                state.rosterErrorCount -= 1;
                if(value['isRequired']) {
                    state.requiredErrorCount -= 1;
                }
            }
        }
    }
}

export function validateRoster(state) {
    state.rosterValidated = true
}

export function invalidateRoster(state) {
    state.rosterValidated = false
}

export function resetWorkspace(state) {
    state.roster = []
    state.coaches = []
    state.rosterValidated = false
}

export function resetRoster(state) {
    state.roster = []
}

export function updateTeamStatus(state, teamId) {
    const team = state.event.teams.find(team => team.id === teamId);

    team.isRostered = true;

    state.event.teams.splice(state.event.teams.findIndex(team => team.id === teamId), 1, team);
}
export function setIntegratedIdentity(state, identity) {
    state.auth.integratedIdentity = identity
}

export function setMyAccount(state, me) {
    state.me = me;
}

export function addAthlete(state, athlete) {
    state.me.organization.athletes.push(athlete)
}

export function addTeam(state, team) {
    state.me.organization.teams.push(team)
}